/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Hero_EyebrowInputs */

const en_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Egly Method`)
};

const es_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método Egly`)
};

const de_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-Methode`)
};

const zh_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ar_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهج Egly`)
};

const fr_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode Egly`)
};

const vi_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp Egly`)
};

const sw_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu ya Egly`)
};

const th_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const bs_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly metoda`)
};

const ja_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ko_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드`)
};

const pt_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Egly Method`)
};

const it_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’Egly Method`)
};

const sv_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const nl_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Egly Method`)
};

const da_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const nb_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const fi_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const pl_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ru_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод Egly`)
};

const tr_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const hi_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const id_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ms_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const cs_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const el_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος Egly`)
};

const he_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const af_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-metode`)
};

const hu_injury_content_hero_eyebrow = /** @type {(inputs: Injury_Content_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

/**
* | output |
* | --- |
* | "The Egly Method" |
*
* @param {Injury_Content_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_hero_eyebrow = /** @type {((inputs?: Injury_Content_Hero_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Hero_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_hero_eyebrow(inputs)
	if (locale === "de") return de_injury_content_hero_eyebrow(inputs)
	if (locale === "zh") return zh_injury_content_hero_eyebrow(inputs)
	if (locale === "ar") return ar_injury_content_hero_eyebrow(inputs)
	if (locale === "fr") return fr_injury_content_hero_eyebrow(inputs)
	if (locale === "vi") return vi_injury_content_hero_eyebrow(inputs)
	if (locale === "sw") return sw_injury_content_hero_eyebrow(inputs)
	if (locale === "th") return th_injury_content_hero_eyebrow(inputs)
	if (locale === "bs") return bs_injury_content_hero_eyebrow(inputs)
	if (locale === "ja") return ja_injury_content_hero_eyebrow(inputs)
	if (locale === "ko") return ko_injury_content_hero_eyebrow(inputs)
	if (locale === "pt") return pt_injury_content_hero_eyebrow(inputs)
	if (locale === "it") return it_injury_content_hero_eyebrow(inputs)
	if (locale === "sv") return sv_injury_content_hero_eyebrow(inputs)
	if (locale === "nl") return nl_injury_content_hero_eyebrow(inputs)
	if (locale === "da") return da_injury_content_hero_eyebrow(inputs)
	if (locale === "nb") return nb_injury_content_hero_eyebrow(inputs)
	if (locale === "fi") return fi_injury_content_hero_eyebrow(inputs)
	if (locale === "pl") return pl_injury_content_hero_eyebrow(inputs)
	if (locale === "ru") return ru_injury_content_hero_eyebrow(inputs)
	if (locale === "tr") return tr_injury_content_hero_eyebrow(inputs)
	if (locale === "hi") return hi_injury_content_hero_eyebrow(inputs)
	if (locale === "id") return id_injury_content_hero_eyebrow(inputs)
	if (locale === "ms") return ms_injury_content_hero_eyebrow(inputs)
	if (locale === "cs") return cs_injury_content_hero_eyebrow(inputs)
	if (locale === "el") return el_injury_content_hero_eyebrow(inputs)
	if (locale === "he") return he_injury_content_hero_eyebrow(inputs)
	if (locale === "af") return af_injury_content_hero_eyebrow(inputs)
	if (locale === "hu") return hu_injury_content_hero_eyebrow(inputs)
	return en_injury_content_hero_eyebrow(inputs)
});